// eslint-disable-next-line import/prefer-default-export
export const AccordionStyle = {
  '.MuiCollapse-root': {
    mb: 4,
  },
  '&:before': {
    backgroundColor: 'transparent !important',
  },
  '.MuiAccordionSummary-content': {
    my: 1,
  },
  '.MuiAccordionSummary-root': {
    minHeight: 'auto !important',
    borderBottom: 1,
    borderColor: 'divider',
    pl: 0,
    pr: 1,
  },
  '.MuiAccordionSummary-expanded': {
    minHeight: 'auto !important',
  },
  '.MuiAccordion-root.Mui-expanded': {
    minHeight: 'auto !important',
    my: 1,
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    my: 1,
  },
  '.MuiAccordionDetails-root': {
    px: 0,
    py: 2,
    pb: 0,
  },
};

export const ThumbnailImgStyle = { width: 52, height: 52, mr: 1.75 };

export const avatarStyle = {
  width: 32,
  height: 32,
};

export const sliderStyle = {
  height: 6,
  '&.MuiSlider-root': {
    marginTop: '5px',
    marginBottom: '-5px',
  },
  '& .MuiSlider-thumb': {
    width: 16,
    height: 16,
    border: 2,
    borderColor: 'divider',
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    backgroundColor: 'divider',
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#a5a5a5 !important',
    width: '2px',
    height: '16px',
    top: '16px',
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: '#ff3333  !important',
    },
  },
};

export const playerWrapper = {
  position: 'relative',
  paddingTop: '56.25%', /* Player ratio: 100 / (1280 / 720) */
};

export const reactPlayer = {
  position: 'absolute',
  top: 0,
  left: 0,
};
